import { FileIcon } from '@apia/icons';
import { Box, Close, getVariant, ThemeUIStyleObject } from '@apia/theme';
import { forwardRef, useState } from 'react';
import { IconButton, TIconButton } from '../forms';

export const FileCard = forwardRef(
  (
    {
      name,
      iconsSize,
      additionalButtons,
      className,
      sx,
      width = 'fit-content',
      handleClose,
      onDoubleClick,
      onClick,
      onDropFiles,
      previewProps,
    }: {
      name: string;
      iconsSize?: 'sm' | 'md' | 'lg' | 'xl';
      additionalButtons?: TIconButton[];
      className?: string;
      sx?: ThemeUIStyleObject;
      width?: string;
      handleClose?: (f: string) => void;
      onDoubleClick?: () => void;
      onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
      onDropFiles?: (files: File[]) => void;
      previewProps?: {
        hasPreview?: boolean;
        previewUrl?: string;
      };
    },
    ref,
  ) => {
    const [isDragOver, setIsDragOver] = useState(false);

    return (
      <Box
        {...getVariant('layout.common.components.fileCard')}
        sx={{
          ...sx,
          width,
          ...(isDragOver && onDropFiles
            ? {
                border: '2px dashed #1976d2!important',
                backgroundColor: '#f5faff!important',
              }
            : {}),
        }}
        ref={ref}
        key={name}
        className={`fileCard ${className ?? ''}`}
        onDoubleClick={onDoubleClick}
        onClick={onClick}
        title={name}
        tabIndex={0}
        onDragOver={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsDragOver(true);
        }}
        onDragLeave={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsDragOver(false);
        }}
        onDrop={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsDragOver(false);
          if (onDropFiles && e.dataTransfer?.files?.length) {
            const files = Array.from(e.dataTransfer.files);
            onDropFiles(files);
          }
        }}
      >
        <Box className="fileCard__container">
          <Box className="fileCard__content">
            <FileIcon docName={name} iconSize={iconsSize} />
            <Box as="span" className="fileCard__name">
              {name}
            </Box>
          </Box>
          <Box className="fileCard__additionalButtons">
            {additionalButtons?.map((c) => {
              return (
                <IconButton
                  iconSize={'Md'}
                  {...c}
                  className={`fileCard__additionalButton ${c.className ?? ''}`}
                />
              );
            })}
          </Box>
          {handleClose && (
            <Close
              type="button"
              className="fileCard__delete"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleClose(name);
              }}
            />
          )}
        </Box>
        {previewProps?.hasPreview && previewProps?.previewUrl && (
          <Box className="fileCard__preview">
            <img src={previewProps.previewUrl} alt={name} />
          </Box>
        )}
      </Box>
    );
  },
);
